'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('adsub', {
        url: '/adsub',
        template: '<adsub></adsub>'
    });
}



// WEBPACK FOOTER //
// ./client/app/adsub/adsub.routes.js